import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  :root {
    --primary-color: #0050A6; /* Corporate blue */
    --primary-light: #2979CD;
    --primary-dark: #003B7A;
    --secondary-color: #00BFB3; /* Teal accent */
    --secondary-light: #40DCD2;
    --secondary-dark: #009489;
    --dark-bg: #121F3D; /* Dark blue background */
    --light-bg: #F2F7FF; /* Light blue-tinted background */
    --text-dark: #172B4D; /* Corporate text color */
    --text-muted: #5E6C84;
    --text-light: #FFFFFF;
    --danger-color: #E95A5A;
    --success-color: #5cb85c;
    --grey-100: #f5f7fa;
    --grey-200: #e9edf5;
    --grey-300: #C4CCD4;
    --grey-400: #97A0AF;
    --box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
    --navbar-bg: rgba(18, 31, 61, 0.95); /* Dark blue navbar */
    
    /* Responsive breakpoints */
    --mobile-width: 480px;
    --tablet-width: 768px;
    --desktop-width: 1024px;
    --large-desktop-width: 1440px;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  html {
    font-size: 16px;
    scroll-behavior: smooth;
    
    @media (max-width: 768px) {
      font-size: 15px;
    }
    
    @media (max-width: 480px) {
      font-size: 14px;
    }
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--text-dark);
    background-color: var(--light-bg);
    line-height: 1.6;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    color: var(--text-dark);
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
  }

  section {
    padding: 100px 0; /* Added 100px padding as per user preference */
    
    @media (max-width: 768px) {
      padding: 70px 0;
    }
    
    @media (max-width: 480px) {
      padding: 50px 0;
    }
  }
  
  .section-title {
    color: var(--primary-dark);
    font-size: 2.5rem;
    
    @media (max-width: 768px) {
      font-size: 2rem;
    }
    
    @media (max-width: 480px) {
      font-size: 1.75rem;
    }
  }
  
  .section-accent {
    color: var(--secondary-color);
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
  
  /* Responsive container class */
  .container {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
  }
`;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlobalStyle />
    <App />
  </React.StrictMode>
);
